import React, { useState, useEffect } from 'react';
import { useLayoutContext } from '../../providers/LayoutProvider';
import { queryBuilder } from '../../shared/Utils';
import { AccentedText } from '../AccentedText/AccentedText';
import './NewsLetterSignUp.scss';

export interface NewsLetterSignUpProps {
    heading: string;
    body: string;
}

export const NewsLetterSignUp = ({ heading, body }: NewsLetterSignUpProps) => {
    const { campaignTermsFilter } = useLayoutContext();
    const queryParametersToString = queryBuilder(campaignTermsFilter, false);
    const [queryString, setQueryString] = useState(``);

    useEffect(() => {
        setQueryString(
            `${!queryParametersToString ? `` : queryParametersToString}`
        );
    }, [queryParametersToString]);

    return (
        <section className="themed-container gray news-letter-sign-up">
            <div className="kite-container">
                <div className="news-letter-grid">
                    <h2 className="typestack-title-3">
                        <AccentedText>{heading}</AccentedText>
                    </h2>
                    <div
                        className="news-letter-body"
                        dangerouslySetInnerHTML={{
                            __html: body,
                        }}
                    />
                </div>
                <div className="news-letter">
                    <iframe
                        title="Newsletter Signup"
                        src={`https://go2.spectrumreach.com/l/211312/2022-10-26/8bms4m${queryString}`}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        suppressHydrationWarning
                    ></iframe>
                </div>
            </div>
        </section>
    );
};
